import React, { createContext, useState } from "react";

import PropTypes from "prop-types";

export const RecurrenciesContext = createContext();

export const RecurrenciesProvider = ({ children }) => {
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);

	const toggleDrawer = () => {
		setIsDrawerOpen(prevState => !prevState);
	};

	return (
		<RecurrenciesContext.Provider value={{ isDrawerOpen, toggleDrawer }}>
			{children}
		</RecurrenciesContext.Provider>
	);
};

RecurrenciesProvider.propTypes = {
	children: PropTypes.node.isRequired,
};